import React from "react";

const Footer = () => {
  return (
  
    <footer className="bg-dark text-white text-center py-4">
    <div className="container">
        <div className="row">
          {/* Head Office */}
          <div className="col-md-4">
            <h5>HEAD OFFICE</h5>
            <p>
              Taas Elect Motor Winding Services, <br />
              Industrial Area 4, Behind Danube, <br />
              Shed 18, P. O. Box 20997, Sharjah UAE
            </p>
            <p><a
                href="tel:+971527499912"
                className="text-white text-decoration-none"
              >
                +971-52749-9912
              </a>
              <br/><a
                href="mailto:raj@taasengg.com"
                className="text-white text-decoration-none"
              >
                raj@taasengg.com
              </a>
            </p>
          </div>

          {/* Navigation */}
          <div className="col-md-4">
            <h5>NAVIGATION</h5>
            <ul className="list-unstyled">
              <li>
                <a href="/about" className="text-white text-decoration-none">
                  About Us
                </a>
              </li>
              <li>
                <a href="/services" className="text-white text-decoration-none">
                  Services
                </a>
              </li>
              <li>
                <a href="/contact" className="text-white text-decoration-none">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Follow Us */}
          <div className="col-md-4">
            <h5>FOLLOW US</h5>
            <ul className="list-unstyled">
              <li>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white text-decoration-none"
                >
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white text-decoration-none"
                >
                  Instagram
                </a>
              </li>
              {/* <li>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white text-decoration-none"
                >
                  LinkedIn
                </a>
              </li> */}
            </ul>
          </div>
        </div>
        <div className="text-center mt-3">
          <p>© 2024 Taas Elect Motor Winding Services.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;